import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import TableStructure from "../../CommonComponents/TableStructure";
import { getImageURL } from "../../util/getImage";
import { Image } from "@chakra-ui/react";
import { getAllCalendarFocusOfTheDayData } from "../../services/CalendarFocusOfTheDay";
const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const placeholderImg = `${IMAGE_BASE_PATH}/ui/DummyImage/small.png`

const CalendarFocusOfTheDayTable = () => {
    const [records, setRecords] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState('');
    const [sortOrder, setSortOrder] = useState("asc"); // Sorting state
    const session = useSelector((state) => state.session);
    const limit = 50; // Number of records per page

    // Fetch projects from the API
    const fetchCalendarEvents = async (page, term) => {
        setLoading(true);
        try {
            const result = await getAllCalendarFocusOfTheDayData(limit, page, term);
            if (result?.data) {
                setRecords(citationFactor(result?.data?.data || []));
                setTotalPages(Math.ceil(result?.data?.total / limit));
                setTotalRecords(result?.data?.total);

                if (result.data.page_number && parseInt(result.data.page_number) !== currentPage) {
                    setCurrentPage(parseInt(result.data.page_number));
                }
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
        } finally {
            setLoading(false);
        }
    };

    const citationFactor = (data) => {
        return data?.map((item) => {
            return {
                alias: item?.alias,
                eventStatus: item?.eventStatus,
                direct_url_of_cover_image: item?.eventImage
            }
        })
    }

    const columns = [
        {
            label: "Alias",
            accessor: "alias",
        },
        {
            label: "Image",
            accessor: "direct_url_of_cover_image",
            render: (value) =>
                <Image
                    src={getImageURL(value, "200", "100")}
                    width="200px"
                    height="100px"
                    objectFit="contain"
                    fallbackSrc={placeholderImg}
                    alt="Cover image"
                />
        }
    ]

    // Handle search button click
    const handleSearch = (searchTerm) => {
        if (searchTerm.trim()) {
            isInitialLoad.current = false; // Skip the first render
            setCurrentPage(1); // Reset to page 1 for a new search
            setSearchText(searchTerm);
      fetchCalendarEvents(1, searchTerm);
        }
    };

    const sortRecords = () => {
        const newSortOrder = sortOrder === "asc" ? "desc" : "asc"; // Update sortOrder first
        setSortOrder(newSortOrder);

        const sorted = [...records].sort((a, b) =>
            newSortOrder === "asc"
                ? a.alias.localeCompare(b.alias)
                : b.alias.localeCompare(a.alias)
        );

        setRecords(sorted);
    };

    const isInitialLoad = useRef(true);

    useEffect(() => {
        // if (isInitialLoad.current) {
        //     isInitialLoad.current = false; // Skip the first render
        //     return;
        // }

        fetchCalendarEvents(currentPage, searchText);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    const handleClear = () => {
        setSearchText('');
    fetchCalendarEvents(1, "");
    };

    // Handle page changes
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(parseInt(page));
        }
    };

    return (
        <TableStructure
            isAuthenticated={session?.isAuthenticated}
            handleSearch={handleSearch}
            handleClear={handleClear}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            totalPages={totalPages}
            sortRecords={sortRecords}
            sortOrder={sortOrder}
            loading={loading}
            totalRecords={totalRecords}
            records={records}
            type="calendar/focus-of-the-day"
            title="Calendar Focus Of The Day"
            addOption
            columns={columns}
        />
    );
};

export default CalendarFocusOfTheDayTable;
